import { useContext } from 'react';
import { AppContext } from '@send-legacy-app/Context';

const useShowBubbles = () => {
  const { showBubbles, setShowBubbles } = useContext(AppContext);
  return [showBubbles, setShowBubbles];
};

export default useShowBubbles;
